
export type GetUserById500 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
